// extracted by mini-css-extract-plugin
export default {"Container":"_J_ycp3Nq8PYspGecYYM","RouterLoaderAnimation":"qLRjOZp6F5_N3tu_i_Ga","Spinner":"WiWlT_mq8WAKiGhK0PQG","SpinnerEl":"GQkR2vh2Va4kb9daD7Nj"};